<template>
    <v-container>
        <v-toolbar flat>
            <v-card-actions>
                <v-icon @click="$router.go(-1)" color="secondary"  style="margin-right: 10px">
                    mdi-arrow-left-thick
                </v-icon>
            </v-card-actions>
            
            <v-toolbar-title style=""><b>Subscription Settings</b></v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>


        
        <v-form ref="form" @submit.prevent="savePackagePrice" class="custom_form">
        <v-card>

            <v-row class="custom_dash" justify="space-around">
                <v-col cols="12" md="6">
                        <v-row dense>
                            <v-col cols="6"  class="mx-15 ">
                                <b>One Time Price ($)</b>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6"  class="mx-4">
                               
                                 <v-text-field
                                v-model="onetimePrice"
                                outlined
                                dense 
                                clearable
                                :rules="oneTimeRules"
                                :success="oneTimeRulesSuccess" class="shrink mx-10"
                            ></v-text-field>          
                               
                            </v-col>
                        </v-row>
                </v-col> 

                <v-col cols="12" md="6">
                        <v-row dense>
                            <v-col cols="6"  class="mx-15 ">
                                <b>Monthly Price ( per month ($) )</b>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6"  class="mx-4">
                               
                                 <v-text-field
                                v-model="monthlyPrice"
                                outlined
                                dense 
                                clearable
                                :rules="monthlyRules"
                                :success="monthlyRulesSuccess" class="shrink mx-10"
                            ></v-text-field>          
                               
                            </v-col>
                        </v-row>

                </v-col>

                <v-col cols="12" md="6">
                        <v-row dense>
                            <v-col cols="6"  class="mx-15 ">
                                <b>Free Trial Period ( in days )</b>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6"  class="mx-4">
                               
                                 <v-text-field
                                v-model="freeTrialPeriod"
                                outlined
                                dense 
                                clearable
                                :rules="freeTrialPeriodRules"
                                :success="freeTrialPeriodSuccess" class="shrink mx-10"
                            ></v-text-field>          
                               
                            </v-col>
                        </v-row>

                </v-col>

                <v-col cols="12" md="6">
                        <v-row dense>
                            <v-col cols="6"  class="mx-15 ">
                                <b>Remind Free Trial Expiry before <br />( in days )</b>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6"  class="mx-4">
                               
                                 <v-text-field
                                v-model="freeTrialRemindPeriod"
                                outlined
                                dense 
                                clearable
                                :rules="freeTrialRemindPeriodRules"
                                :success="freeTrialRemindPeriodSuccess" class="shrink mx-10"
                            ></v-text-field>          
                               
                            </v-col>
                        </v-row>

                </v-col>


                <v-col cols="12" md="12">
                        <v-row dense>
                            <v-col cols="6"  class="mx-15 ">
                                <b>Subscription Grace Period <br />( in days )</b>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6"  class="mx-4">
                               
                                 <v-text-field
                                v-model="subscriptionGracePeriod"
                                outlined
                                dense 
                                clearable
                                :rules="subscriptionGracePeriodRules"
                                :success="subscriptionGracePeriodSuccess" class="shrink mx-10"
                            ></v-text-field>          
                               
                            </v-col>
                        </v-row>

                </v-col>

            </v-row>

            <v-row v-if="errorMessage || successMessage">
                <v-col cols="6" offset-md="2">
                    <v-alert v-if="errorMessage" type="error">
                        {{errorMessage}}
                    </v-alert>
                    <v-alert v-if="successMessage" type="success">
                        {{successMessage}}
                    </v-alert>
                </v-col>
            </v-row>

              <v-divider></v-divider>
                    
                    <v-row>
                        <v-col cols="10">
                            <v-card-actions style="justify-content:center;">
                                <v-btn class="mx-5" text @click="$router.go(-1)">cancel</v-btn>
                                <v-btn
                                    class="mx-5"
                                    :disabled="disabled"
                                    type="submit"
                                    color="secondary"
                                    width="90"
                                    @click="savePackagePrice"
                                    >Submit</v-btn
                                >
                            </v-card-actions>
                        </v-col>
                    </v-row>
                    </v-card>
        </v-form>
    </v-container>
</template>

<script>
//import Course from "../../models/Course";
//import {mapMutations } from "vuex";
import axios from "axios";
import url1 from "../../../config.js";

export default {
     beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id)
                   vm.$router.push("/");
            }, 0);
        });
    },
    name: "PackagePrice",
    data() {
        return {

            onetimePrice: "",
            monthlyPrice: "",
            freeTrialPeriod: "",
            freeTrialRemindPeriod: "",
            subscriptionGracePeriod:"",
            url: url1.url,
            successMessage:'',
            errorMessage:'',
            disabled:false,
            oneTimeRulesSuccess: false,
            oneTimeRules: [
                v => {
                    if (v) {
                        this.oneTimeRulesSuccess = true;
                        return true;
                    } else {
                        this.oneTimeRulesSuccess = false;
                        return "One Time price is required";
                    }
                },
                v => !isNaN(Number(v || "")) || "One Time price must be number", //to ask for the models
            ],

            monthlyRulesSuccess: false,
            monthlyRules: [
                v => {
                    if (v) {
                        this.monthlyRulesSuccess = true;
                        return true;
                    } else {
                        this.monthlyRulesSuccess = false;
                        return "Monthly Price is required";
                    }
                },
                v =>  !isNaN(Number(v || "")) || "Monthly price must be number", //to ask for the models
            ],

            freeTrialPeriodSuccess: false,
            freeTrialPeriodRules: [
                v => {
                    if (v) {
                        this.freeTrialPeriodSuccess = true;
                        return true;
                    } else {
                        this.freeTrialPeriodSuccess = false;
                        return "Free Trial Period is required";
                    }
                },
                v =>  !isNaN(Number(v || "")) || "Free Trial Period must be number", //to ask for the models
            ],

            freeTrialRemindPeriodSuccess: false,
            freeTrialRemindPeriodRules: [
                v => {
                    if (v) {
                        this.freeTrialRemindPeriodSuccess = true;
                        return true;
                    } else {
                        this.freeTrialRemindPeriodSuccess = false;
                        return "Free Trial Reminder days is required";
                    }
                },
                v =>  !isNaN(Number(v || "")) || "Free Trial Reminder days must be number", //to ask for the models
            ],

            subscriptionGracePeriodSuccess: false,
            subscriptionGracePeriodRules: [
                v => {
                    if (v) {
                        this.subscriptionGracePeriodSuccess = true;
                        return true;
                    } else {
                        this.subscriptionGracePeriodSuccess = false;
                        return "Subscription Grace Period is required";
                    }
                },
                v =>  !isNaN(Number(v || "")) || "Subscription Grace Period must be number", //to ask for the models
            ],
            

        }
    },
    computed: {
        auth() {
            return this.$store.state.auth;
        }
    },

    methods: {

        savePackagePrice() {
            this.disabled = true;
            //console.log('title', this.course.courseTitle);
            if (this.onetimePrice.trim().length === 0 ||  isNaN(this.onetimePrice)) //earlier 30
            {
                this.errorMessage = 'One Time price should be valid';
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }

            if (this.monthlyPrice.trim().length === 0 ||  isNaN(this.monthlyPrice)) //earlier 30
            {
                this.errorMessage = 'Monthly price should be valid';
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }            

            if (this.freeTrialPeriod.trim().length === 0 ||  isNaN(this.freeTrialPeriod)) //earlier 30
            {
                this.errorMessage = 'Free Trial period should be valid';
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }            

            if (this.freeTrialRemindPeriod.trim().length === 0 ||  isNaN(this.freeTrialRemindPeriod)) //earlier 30
            {
                this.errorMessage = 'Free Trial Reminder days should be valid';
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }            


            if (this.subscriptionGracePeriod.trim().length === 0 ||  isNaN(this.subscriptionGracePeriod)) //earlier 30
            {
                this.errorMessage = 'Subscription Grace Period should be valid';
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                return;
            }            


                 axios
                    .post(
                        this.url+"/api/packages/update",
                        {
                            onetimePrice: this.onetimePrice.trim(),
                            monthlyPrice: this.monthlyPrice.trim(),

                            freetrialperiod: this.freeTrialPeriod.trim(),
                            freetrialreminder: this.freeTrialRemindPeriod.trim(),
                            subscriptionGracePeriod: this.subscriptionGracePeriod.trim(),

                        },
                        {
                            headers: { "x-auth-token": this.auth.token }
                        }
                    )
                    .then(res => {
                        console.log("save package", res);
                        if(res.data.success){
                           this.successMessage = res.data.message;
                            setTimeout(() => ( this.successMessage = ""), 5000);
                        }else{
                           this.errorMessage = res.data.message;
                            setTimeout(() => ( this.errorMessage = ""), 5000);

                        }


                        this.disabled = false;
                        return;
                    })
                    .catch(err => {
                        console.error(err.message);
                        this.disabled = false;
                        this.errorMessage = 'Some error occured while updating data. Please try again';
                        setTimeout(() => (this.errorMessage = ""), 5000);
                        this.disabled = false;
                        return;
        

                    });

           /*  Course.postCourse( this.course, this.auth.token)
            .then( res => {
                this.disabled = false;
                console.log('res', res);
                this.successMessage = 'Course added successfully';
                setTimeout(() => (this.successMessage = ""), 5000);
                this.$refs.form.reset();
            })
            .catch( err => {
                this.errorMessage = err.response.data;
                setTimeout(() => (this.errorMessage = ""), 5000);
                this.disabled = false;
                this.$refs.form.reset(); 
            }); */
        },

        getPacakgePrice() {
            axios
                .get(
                    this.url+"/api/packages/list",
                    {
                            headers: { "x-auth-token": this.auth.token }
                    }
                )
                .then(
                    res => {
                        console.log(res.data.data);
                        this.monthlyPrice = res.data.data.monthlyPrice;
                        this.onetimePrice = res.data.data.onetimePrice;
                        this.freeTrialPeriod = res.data.data.freetrialPeriod;
                        this.freeTrialRemindPeriod = res.data.data.freetrialReminder;
                        this.subscriptionGracePeriod = res.data.data.subscriptionGracePeriod;
                        
                    },
                    err => {
                        console.log(err);
                    }
                )
                .catch(err => {
                    console.error(err);
                });
        },

        clearForm(){
            this.$refs.form.resetValidation();
        },

    }, 
    mounted(){
        this.getPacakgePrice()
    }
}
</script>
<style scoped>
form.v-form.custom_form{
    margin: 10px 0 0;
    border-top:none;
}
.custom_form >>> .v-card {
    padding-top: 20px;
}
</style>